export default function loadTradeform() {
  const body = document.querySelector('body'),
    tradeForm = document.querySelector('#tradeForm'),
    formsHeader = document.querySelector('.forms-header'),
    submitButton = tradeForm.querySelector('#tradeSubmit'),
    instructions = formsHeader.querySelector('.instructions'),
    thankYou = formsHeader.querySelector('.thank-you');

  /* Account Type Selection */
  const tradeButton = tradeForm.querySelector("[data-toggle-value='trade']"),
    hospButton = tradeForm.querySelector("[data-toggle-value='hospitality']"),
    tradeCopy = tradeForm.querySelector("[data-toggle-group='trade']"),
    hospCopy = tradeForm.querySelector("[data-toggle-group='hospitality']");

  tradeButton.addEventListener('click', (e) => {
    tradeCopy.classList.remove('hide');
    hospCopy.classList.add('hide');
  });

  hospButton.addEventListener('click', (e) => {
    hospCopy.classList.remove('hide');
    tradeCopy.classList.add('hide');
  });

  submitButton.addEventListener('click', (e) => {
    e.preventDefault();

    /* Text input Required Validation */
    let textInputs = document.querySelectorAll("input[type='text']");
    let requiredInputs = Array.from(textInputs).filter((elem) => elem.matches('[required]'));

    for (const elem of requiredInputs) {
      elem.value == '' ? elem.classList.add('invalid') : elem.classList.remove('invalid');
    }

    let is_valid = null;
    let invalidExists = tradeForm.querySelectorAll('.invalid').length > 0;

    is_valid = invalidExists ? false : true;

    if (is_valid == true) {
      /* GET DATA FROM CHECKBOXES AND RADIO BUTTONS */
      let checkedDataStr = '';

      const getCheckedData = (inputName) => {
        let checkedInputs = document.querySelectorAll(`input[name="${inputName}"]:checked`);
        let checkedArr = [...checkedInputs].map((input) => input.value);
        let checkedStr = '';

        /*
         * If the input is a radio button or i suppose a checkbox with only one
         * option, then don't add a comma, otherwise do.
         */
        for (const [i, value] of checkedArr.entries()) {
          checkedStr = i === 0 ? (checkedStr += value) : (checkedStr += `,${value}`);
        }

        /* Add the input name so data goes to the correct google sheet column */
        let checkedData = `&${inputName}=` + encodeURIComponent(checkedStr);
        checkedDataStr += checkedData;

        return checkedDataStr;
      };

      /* Supply the checkboxes and radio button names */
      let checkedInputs = ['HearAboutUs', 'ProductScope', 'TaxExempt', 'accountType'];
      for (const inputName of checkedInputs) {
        getCheckedData(inputName);
      }

      /* GET DATA FROM TEXT INPUTS */
      /* go through each input and pair the name with the value */
      const getTextData = (input) => {
        let textInputStr = `&${input.name}=` + encodeURIComponent(`${input.value}`);
        return textInputStr;
      };

      let textInputs = document.querySelectorAll("input[type='text']");
      let textInputArr = [...textInputs].map((input) => getTextData(input));
      let textDataStr = '';

      /* go through each input name/input value pair and concatenate them */
      for (let textInput of textInputArr) {
        textDataStr += textInput;
      }

      let serializedData = textDataStr + checkedDataStr;
      // console.log(serializedData);

      /*
       * Let's disable the inputs for the duration of the Ajax request.
       * Note: we disable elements AFTER the form data has been serialized.
       * Disabled form elements will not be serialized.
       * url: "https://script.google.com/macros/s/AKfycbzhig8jrw3xhKSzuCfAIlEZuaMvKMJXJVCMqblExO5WklQtCWp12PII2SN4Yu0saS0/exec",
       */
      const inputs = tradeForm.querySelectorAll('input');
      for (const input of inputs) {
        input.setAttribute('disabled', '');
      }

      /*
       * https://www.youtube.com/watch?v=fGYQJAlLD68
       * form data must get passed as x-www-form-urlencoded
       *
       * application/x-www-form-urlencoded: the keys and values are encoded in
       * key-value tuples separated by '&', with a '=' between the key and the
       * value.
       */

      let scriptURL = 'https://script.google.com/macros/s/AKfycbzhig8jrw3xhKSzuCfAIlEZuaMvKMJXJVCMqblExO5WklQtCWp12PII2SN4Yu0saS0/exec';
      fetch(scriptURL, {
        method: 'POST',
        body: serializedData,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      })
        .then((response) => {
          /* Reenable the inputs */
          const inputs = tradeForm.querySelectorAll('input');
          for (const input of inputs) {
            input.removeAttribute('disabled');
          }
          /* Send tracking of submit to GTM */
          dataLayer.push({ event: 'dl_corporate_gifting_form_submit' });
          /* Hide the form */
          tradeForm.style.display = 'none';
          instructions.style.display = 'none';
          thankYou.style.display = 'block';
        })
        .catch((error) => {
          // console.log('ERROR');
          submitButton.disabled = false;
        });
    }
  });
}
